import useQueryPlus from "utils/useQueryPlus"
import PagesLayout from "../layouts/PagesLayout"
import { fetchInitials } from "../queries"
import { NextSeo } from "next-seo"
import useT from "utils/useT"

const Home = () => {
  const t = useT()
  useQueryPlus({
    queryFn: fetchInitials,
    queryKey: ["initialApps"],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    gcTime: Infinity,
    staleTime: Infinity,
  })

  return (
    <>
      <NextSeo
        canonical={"https://www.appollow.net"}
        openGraph={{ url: "https://www.appollow.net", title: t.og.title, description: t.og.description, siteName: "Appollow" }}
      />
      <PagesLayout />
    </>
  )
}

export default Home
